<script lang="ts">
	import "./app.css";
	import { writable, type Writable } from "svelte/store";
	import { onMount, setContext } from "svelte";
	// import Auth from "./Auth.svelte";
	import type { Supabase } from "./structure";
	import WelcomeOffer from "./WelcomeOffer.svelte";
	import Withdraw from "./Withdraw.svelte";

	const user: Writable<any | undefined> = writable();
	export const supabase: Supabase = writable(
		(window as any).supabase.createClient(
			"https://oaxneyeahpxwqtrnreej.supabase.co",
			"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im9heG5leWVhaHB4d3F0cm5yZWVqIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MDgzNDU4MTEsImV4cCI6MjAyMzkyMTgxMX0.9Ma_XOjs_uRn7e9FQFbZKcMohy4Yg7o4DxhZek7Ej78",
		),
	);

	setContext("user", user);
	setContext("supabase", supabase);

	let loading = true;
	let hash: string;

	onMount(async () => {
		const savedUser = localStorage.getItem("gambler");
		const url = new URL(window.location.href);
		hash = url.hash;
		url.hash = "deposit";
		localStorage.setItem("depositPath", url.href);
		url.hash = "withdraw";
		localStorage.setItem("withdrawPath", url.href);
		if (Boolean(savedUser)) {
			$user = JSON.parse(savedUser);

			const { data, error } = await $supabase
				.from("users")
				.select("*")
				.eq("id", $user?.id);

			if (!error && data.length != 0) {
				const result = data[0];
				if ($user.data.balance !== result.data.balance) {
					setTimeout(async () => {
						$supabase
							.from("users")
							.update({
								data: $user.data,
							})
							.eq("id", $user.id);
					});
				}

				setTimeout(async () => {
					$supabase
						.channel("channel")
						.on(
							"postgres_changes",
							{
								event: "*",
								schema: "public",
								table: "users",
							},
							async (data) => {
								if (data.eventType === "DELETE") return;
								if (data.new.id !== $user.id) return;
								localStorage.setItem(
									"gambler",
									JSON.stringify(data.new),
								);
							},
						)
						.subscribe();
				});
				localStorage.setItem("gambler", JSON.stringify(data[0]));
			}
		}

		loading = false;
	});

	let showFundOptions = false;
	delete localStorage["loaded"];

	let showInterval = setInterval(() => {
		showFundOptions = Boolean(localStorage.getItem("loaded"));
		if (showFundOptions) {
			clearInterval(showInterval);
		}
	}, 1000);
</script>

{#if !loading}
	{#if $user === undefined}
		<WelcomeOffer />
	{:else if hash === ""}
		<div class="w-full h-screen relative">
			<iframe
				class="w-full h-screen"
				src="/game.html"
				title="Play game"
				frameborder="0"
			></iframe>
			{#if showFundOptions}
				<div
					class="flex justify-center align-middle place-items-center absolute bottom-0 left-0 w-full"
				>
					<div
						class="max-w-lg p-2 rounded-md flex gap-2 border-white border text-white bg-purple-700 w-full"
					>
						<button
							on:click={() => {
								hash = "#deposit";
							}}
							class="rounded-md p-2 flex-1 bg-green-500"
							>Deposit</button
						>
						<button
							on:click={() => {
								hash = "#withdraw";
							}}
							class="rounded-md p-2 flex-1 bg-orange-500"
							>Withdraw</button
						>
					</div>
				</div>
			{/if}
		</div>
	{:else}
		<section
			class="fixed inset-0 flex items-center justify-center bg-cover bg-center bg-no-repeat"
			style={"background-image: url(/Background.jpeg);"}
		>
			<div class="container p-4 bg-white rounded-lg shadow-lg max-w-md">
				<div class="space-y-4 text-center">
					<h1
						class="text-3xl font-bold tracking-tighter sm:text-4xl md:text-5xl/none"
					>
						{hash === "#deposit" ? "Deposit!" : "Cashout"}
					</h1>
				</div>
				<div class="max-w-sm space-y-4 mt-4">
					<div class="flex flex-col space-y-2">
						{#if hash === "#deposit"}
							<label>
								Amount
								<div
									class="flex justify-between overflow-hidden align-middle place-items-center w-full rounded-md border border-input bg-background text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
								>
									<input
										class="h-10 flex-1 px-3 py-2 border-none outline-none"
										placeholder="0.0"
										autocomplete="off"
										type="text"
										inputmode="decimal"
									/>
									<span class="px-3 py-2">USD</span>
								</div>
							</label>
							<button
								on:click
								class="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 bg-primary text-primary-foreground hover:bg-primary/90 h-10 px-4 py-2 w-full"
								>Proceed</button
							>
						{:else}
							<Withdraw balance={$user.data.balance} />
						{/if}
					</div>

					<!-- <div class="text-sm text-center">
						<span class=""
							>Don't have an account? <button
								on:click
								class="text-blue-600 font-semibold"
								>Register</button
							></span
						>
					</div> -->
				</div>
			</div>
		</section>
	{/if}
{:else}
	<div
		style:background-image="url(/Background.jpeg)"
		class="w-full h-screen bg-cover text-white flex justify-center align-middle place-items-center"
	>
		<h1 class="text-2xl lg:text-6xl font-bold">Loading....</h1>
	</div>
{/if}
